export default {
    fields: [
        {
            name: 'address_postCode',
            field: 'PostalCode',
            mode: (pca) => pca.fieldMode.SEARCH,
        },
        {
            name: 'address1',
            field: 'Line1',
            mode: (pca) => pca.fieldMode.Preserve,
        },
        {
            name: 'address2',
            field: 'Line2',
            mode: (pca) => pca.fieldMode.Preserve,
        },
        {
            name: 'townCity',
            field: 'City',
            mode: (pca) => pca.fieldMode.Preserve,
        },
        {
            name: 'county',
            field: 'Province',
            mode: (pca) => pca.fieldMode.Preserve,
        },
        {
            name: 'postcode',
            field: 'PostalCode',
            mode: (pca) => pca.fieldMode.Preserve,
        },
        {
            name: 'country',
            field: 'CountryName',
            mode: (pca) => pca.fieldMode.COUNTRY,
        },
    ],
}
